import React, { useRef } from "react";
import TagButton from "../../TagButton/TagButton";

const TagsModal = ({ tags, setTags }) => {
  const ref = useRef();
  return (
    <div
      ref={ref}
      id="tagsModal"
      className="absolute top-56 sm:top-7 right-1/2 sm:right-0 transform translate-x-1/2 sm:transform-none  z-50 rounded-md p-4 shadow-2xl bg-white w-72 flex flex-col gap-4 text-black"
      onMouseLeave={() => {
        ref.current.style.opacity = null;
        ref.current.style.display = null;
      }}
    >
      <div className="flex justify-between">
        <h1 className="font-semibold text-xl">Tags:</h1>
        <div
          onClick={() => {
            ref.current.style.opacity = "0";
            setTimeout(() => {
              ref.current.style.display = "none";
            }, 200);
          }}
        >
          <span className="cursor-pointer px-2 select-none">x</span>
        </div>
      </div>

      <span className="flex gap-3 flex-wrap max-w-full ">
        {Object.keys(tags).map((tag) => (
          <TagButton
            key={tag}
            tag={tag}
            active={tags[tag] === true}
            handleClick={setTags}
          />
        ))}
      </span>
    </div>
  );
};

export default TagsModal;
